import { render } from "./RntrcPrestacaoContas.vue?vue&type=template&id=5599750c"
import script from "./RntrcPrestacaoContas.vue?vue&type=script&lang=ts"
export * from "./RntrcPrestacaoContas.vue?vue&type=script&lang=ts"
script.render = render

export default script